'use client'

import { useEffect, useRef, useState } from 'react'
import { CUSTOM_HTML_SANDBOX, customHtmlSrcDoc } from '../serialize/customHtml'

/** Scripts and forms are disabled. Same-origin permits parent measurement;
 * no untrusted script can access either document. CSS stays in the frame. */
export function CustomHtmlFrame({ html, className, title = 'Custom HTML' }: {
  html: string
  className?: string
  title?: string
}) {
  const frame = useRef<HTMLIFrameElement>(null)
  const cleanup = useRef<(() => void) | null>(null)
  const [height, setHeight] = useState(240)
  useEffect(() => () => cleanup.current?.(), [])

  return <iframe
    ref={frame}
    className={className}
    title={title}
    data-rich-content="custom-html"
    sandbox={CUSTOM_HTML_SANDBOX}
    referrerPolicy="no-referrer"
    srcDoc={customHtmlSrcDoc(html)}
    style={{ width: '100%', height, border: 0, display: 'block' }}
    onLoad={() => {
      cleanup.current?.()
      const body = frame.current?.contentDocument?.body
      if (!body) return
      const measure = () => setHeight(Math.max(160, Math.min(20000, Math.ceil(body.getBoundingClientRect().height))))
      const observer = new ResizeObserver(measure)
      observer.observe(body)
      measure()
      cleanup.current = () => observer.disconnect()
    }}
  />
}
